import { AnimatePresence, motion } from "framer-motion";
import React, { useContext, useRef, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { FooterContext } from "../../../App";
import IconBarre from "../../../components/CustomIcons/IconBarre/IconBarre";
import PosteTypeIcon from "../../../components/CustomIcons/PosteTypeIcon/PosteTypeIcon";
import StockageTypeIcon from "../../../components/CustomIcons/StockageTypeIcon/StockageTypeIcon";
import ResizableTable from "../../../components/ResizableTable/ResizableTable";
import ProductStatutBadge from "../../../components/badgeComponents/ProductStatutBadge/ProductStatutBadge";
import config from "../../../config/config";
import { FreeSecondNavBarContext } from "../Production";
import ModalProduit from "./ModalProduit/ModalProduit";

function Postes() {
  const searchBoxRefContext = useContext(FreeSecondNavBarContext);
  const [showProduit, setShowProduit] = useState(false);
  const [idProduit, setIdProduit] = useState(null);
  const footerRefs = useContext(FooterContext);
  const apiUrl = config.apiUrl;
  const resizableTableRef = useRef();

  const handleShowProductModal = (idProduit) => {
    setIdProduit(idProduit);
    setShowProduit(true);
  };

  const handleHideProductModal = () => {
    resizableTableRef.current.refreshTable();
    setShowProduit(false);
  };

  const tableConfig = [
    {
      nom: "Statut",
      render: (row) => (
        <ProductStatutBadge
          idStatut={row.statut.id}
          libelleStatut={row.statut.libelle}
          type="badge"
          iconSize={15}
        />
      ),
      width: 200,
    },
    {
      nom: "Commande",
      render: (row) => parseInt(row.codeBarre.cmd),
    },
    {
      nom: "Extension",
      render: (row) => row.codeBarre.extension,
      width: 90,
      center: true,
    },
    {
      nom: "Position",
      render: (row) => parseInt(row.codeBarre.position),
      width: 80,
      center: true,
    },
    {
      nom: "Repère quantité",
      render: (row) => parseInt(row.codeBarre.repere_quantite),
      width: 120,
      center: true,
    },
    {
      nom: "Elément",
      render: (row) =>
        parseInt(row.codeBarre.element) === 0 ? (
          <>Dormant</>
        ) : (
          <>Ouvrant {parseInt(row.codeBarre.element)}</>
        ),
      width: 80,
    },
    {
      nom: "ID",
      render: (row) => row.id,
      width: 50,
      center: true,
    },
    {
      nom: "Dernier scan le",
      render: (row) => row.last_mouvement.creation,
      width: 180,
      center: true,
    },
    {
      nom: "Dernier emplacement",
      render: (row) =>
        row.last_mouvement.emplacement.type.libelle === "Stockage" ? (
          <>
            <StockageTypeIcon
              idStockageType={row.mouvement_stockage_or_poste.type.id}
              size={2.7}
              className="me-2"
            />
            {row.mouvement_stockage_or_poste.nom}
          </>
        ) : (
          <>
            <PosteTypeIcon
              idPosteType={row.mouvement_stockage_or_poste.type.id}
              size={2.7}
              className="me-2"
            />
            {row.mouvement_stockage_or_poste.nom}
          </>
        ),
      width: 220,
    },
    {
      nom: "Indice de fabrication",
      render: (row) => row.indice,
      width: 150,
      center: true,
    },
    {
      nom: "Barre",
      render: (row) => <IconBarre barre={row.codeBarre.barre} size={20} />,
      width: 60,
      center: true,
    },
    {
      nom: "Enregistré le",
      render: (row) => row.creation,
      width: 180,
      center: true,
    },
    {
      nom: "Enregistré par",
      render: (row) => <>{row.operateur.prenom + " " + row.operateur.nom}</>,
      width: 200,
      center: true,
    },
  ];

  const cardConfig = {
    header: (row) => row.codeBarre.cmd,
    headerClass: () => "bg-aluminium",
    text: (row) => (
      <>
        id: {row.id} <br />
        creation: {row.creation}
      </>
    ),
  };

  return (
    <>
      <ModalProduit
        show={showProduit}
        handleClose={handleHideProductModal}
        idProduit={idProduit}
      ></ModalProduit>
      <Container fluid className="ps-0">
        <Row>
          <Col>
            <Card className="border-0">
              <AnimatePresence>
                <motion.div
                  initial={{ opacity: 0, y: 25 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <ResizableTable
                    ref={resizableTableRef}
                    urlFetch={apiUrl + "/product-datatable"}
                    limit={50}
                    heightAdjust={37}
                    indexOrder="mouvement_creation"
                    viewModeInit="table"
                    indexSort={7}
                    sortInit="DESC"
                    searchInputRef={searchBoxRefContext}
                    paginationRef={footerRefs && footerRefs.middle}
                    filterResultRef={footerRefs && footerRefs.start}
                    totalRef={footerRefs && footerRefs.end}
                    TableConfig={tableConfig}
                    switchViewRef={searchBoxRefContext}
                    tableConfig={tableConfig}
                    cardConfig={cardConfig}
                    rowClick={handleShowProductModal}
                    autoRefresh={60}
                  />
                </motion.div>
              </AnimatePresence>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Postes;
